function loggedOutQuery(query) {
  const raw = query && query.loggedOut;
  const flag = Array.isArray(raw) ? raw[0] : raw;
  return String(flag || '') === '1';
}

function clearStaffSession(storage, session) {
  try {
    if (storage) storage.removeItem('token');
  } catch (error) {
    /* storage can be unavailable */
  }
  try {
    if (session) session.removeItem('redirectAfterLogin');
  } catch (error) {
    /* storage can be unavailable */
  }
}

module.exports = {
  loggedOutQuery,
  clearStaffSession,
};
